module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctc2a",
    attrs: {
      "id": "ch1a"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e60"
    }
  }, [_vm._v("Thanks to my husband, Doug, for his help and encouragement during this endeavor. Thanks also to my agent, Barb Doyen, for her clear head and calm nature. My editor, Kate Burgo, deserves thanks for her patience and belief in me. And thanks to my father-in-law and his wife, T.E. and Dagmar, for supporting me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-627b979e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth_ISBNXXXXXXXXX_epub_c6_r1.vue
// module id = 78
// module chunks = 0